import { ThemeOptions } from '@mui/material';

import { capitalDesignTokens } from '../../capital_design_tokens';

export const MuiDialog: ThemeOptions['components']['MuiDialog'] = {
  defaultProps: {},
  styleOverrides: {
    paper: ({ theme }) => ({
      boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
      '.MuiDialog__close-button': {
        position: 'absolute',
        right: 10,
        top: 10,
        color: theme.palette.text.disabled
      }
    })
  }
};

export const MuiDialogTitle: ThemeOptions['components']['MuiDialogTitle'] = {
  defaultProps: {
    variant: 'h3',
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold
  },
  styleOverrides: {
    // 20px vertical / 24px horizontal, per the CDS 37 Dialog and Modal frames. Both frames
    // specify the same value, which is what makes this a theme concern rather than a
    // per-component one.
    root: ({ theme }) => ({
      padding: theme.spacing(2.5, 3),
      '.MuiSvgIcon-root': {
        verticalAlign: 'top',
        width: theme.spacing(3),
        height: theme.spacing(3),
        marginRight: theme.spacing(2)
      }
    })
  }
};

export const MuiDialogContent: ThemeOptions['components']['MuiDialogContent'] = {
  defaultProps: {},
  styleOverrides: {
    root: {
      paddingTop: 0
    }
  }
};

export const MuiDialogContentText: ThemeOptions['components']['MuiDialogContentText'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(1, 0),
      color: theme.palette.text.primary
    })
  }
};

export const MuiDialogActions: ThemeOptions['components']['MuiDialogActions'] = {
  defaultProps: {},
  styleOverrides: {
    // Matches the header at 20px vertical / 24px horizontal. Previously 24px all round,
    // which made every dialog footer 8px taller than the frames specify.
    root: ({ theme }) => ({
      padding: theme.spacing(2.5, 3)
    })
  }
};
